import { DEFAULT_PROFILE_PIC, PRO } from '../assets/icons';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { Button } from '@wot/components';
import { useEffect, useState } from 'react';
import { ITrialClass, ITutor } from '@wot/typings';
import xhr from '../utils/fetch';
import { getAttendacePercentage } from '../utils/functions';

export default function TutorCard({ item }: { item: ITutor }) {
  const name = item.personal.data.name;
  const profilePic = item.personal.data.profilePic;
  const categories = item.profession.data.categories;
  const [studentsCount, setStudentsCount] = useState(0);
  const [totalSessions, setTotalSessions] = useState<ITrialClass[]>([]);

  useEffect(() => {
    xhr({
      url: `/t/${item._id}/stats/students-count`,
      method: 'GET'
    })
      .then((res) => setStudentsCount(res.data.count || 0))
      .catch((err) => err);
  }, []);

  // Total Sessions
  useEffect(() => {
    if (item?._id) {
      xhr({
        url: `/t/${item?._id}/sessions`,
        method: 'GET',
        params: {
          type: 'plan',
          status: 'completed'
        }
      })
        .then((res) => {
          if (res.status === 'OK') {
            setTotalSessions(res.data);
          }
        })
        .catch(() => {});
    }
  }, []);

  return (
    <>
      <Tooltip title={`Click on ${name}'s profile to view more details`} placement="top" arrow>
        <Link to={`/tutor-management/manage/${item._id}`} className="w-full">
          <div className=" group flex flex-col border border-neutralGray3 m-2 p-2 rounded-lg cursor-pointer hover:bg-neutralBlue2">
            <div className="flex justify-end">
              {item?.agreement?.level === 'premium' ? (
                <Tooltip title="Premium Tutor" arrow>
                  <img src={PRO} alt="Pro badge" className="h-7 w-7" />
                </Tooltip>
              ) : (
                <div className="h-7 w-7" />
              )}
            </div>
            <div className="flex flex-col gap-2 items-center py-4">
              <div className="flex flex-col items-center gap-1">
                <div className="h-24 w-24">
                  <img
                    src={profilePic === '' ? DEFAULT_PROFILE_PIC : profilePic}
                    alt="User Pic"
                    className="rounded-full h-24 w-24 object-cover"
                  />
                </div>
                <div className="my-2">
                  <span className="text-xl font-medium">{name || `Ayesha`}</span>
                </div>
              </div>
              <div className="flex justify-center items-center divide-x">
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">{studentsCount}</span>
                  <span className="text-xs font-medium text-neutralGray2 text-center">Students</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">
                    {getAttendacePercentage(
                      totalSessions.filter((i) => i.attendance && i.attendance.student === 'present').length,
                      totalSessions.length
                    )}
                    %
                  </span>
                  <span className="text-xs font-medium text-neutralGray2 text-center">Attendance</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">
                    {item.experience.data.filter((i) => i.type === 'online').length}
                  </span>
                  <span className="text-xs font-medium text-neutralGray2">Online Exp.</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  {item.experience.data.filter((i) => i.type === 'offline').length}
                  <span className="text-xs font-medium text-neutralGray2">Offline Exp.</span>
                </div>
              </div>
              <div className="flex justify-center flex-wrap py-2">
                {categories.map((item: any, i: any) => (
                  <span
                    className="rounded-full border bg-neutralBlue2 text-xs font-medium px-3 py-1 mx-1 mt-2 group-hover:bg-white"
                    key={i}
                  >
                    {item.name}
                  </span>
                ))}
              </div>
              <Link
                to={`/tutor-management/manage/${item._id}`}
                className="flex w-full max-w-[150px] items-center justify-center"
              >
                <Button text="View details" type="secondary" onClick={() => {}} />
              </Link>
            </div>
          </div>
        </Link>
      </Tooltip>
    </>
  );
}
